import LoadingCircles from 'root/src/client/v2/common/components/LoadingCircles';
import { usePickingWinner } from 'root/src/client/web/giveaway/features/GiveawaySection/hooks/usePickingWinner';
export const PickingWinner = () => {
    usePickingWinner();
    return (<div className="flex flex-col justify-center items-center gap-2">
			<h1 className="font-mono uppercase font-bold">Picking winner</h1>
			<LoadingCircles width={60} height={60}/>
		</div>);
};
